import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const DirectFloatingContact = () => {
  const contacts = [
    {
      icon: MessageCircle,
      label: 'WhatsApp',
      color: 'bg-green-400 hover:bg-green-400',
      action: () => window.open('https://wa.me/919467855781', '_blank')
    },
    {
      icon: Phone,
      label: 'Call',
      color: 'bg-blue-500 hover:bg-blue-600',
      action: () => window.location.href = 'tel:+919728115781'
    }
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {contacts.map((contact, index) => {
        const Icon = contact.icon;
        return (
          <button
            key={contact.label}
            onClick={contact.action}
            className={`
              flex items-center justify-center w-14 h-14 rounded-full
              ${contact.color} text-white shadow-xl
              transition-all duration-300 hover:scale-110
              transform hover:-translate-y-1
              border-2 border-white/20
              animate-in fade-in zoom-in
            `}
            style={{ 
              animationDelay: `${index * 200}ms`,
              animationDuration: '0.6s'
            }}
            aria-label={contact.label}
          >
            <Icon size={24} />
          </button>
        );
      })}
    </div>
  );
};

export default DirectFloatingContact;